(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TeamManagementDeleteController', TeamManagementDeleteController);

    TeamManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'Team'];

    function TeamManagementDeleteController ($uibModalInstance, entity, Team) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            Team.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
